function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.168,
    height: 73.168,
    viewBox: "0 0 73.168 73.168"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.242 14.425h64.684c2.344 0 4.242-1.933 4.242-4.324 0-2.385-1.898-4.325-4.242-4.325H4.242C1.898 5.776 0 7.716 0 10.101c0 2.392 1.898 4.324 4.242 4.324zm64.684 17.834H4.242C1.898 32.259 0 34.2 0 36.584c0 2.393 1.898 4.325 4.242 4.325h64.684c2.344 0 4.242-1.933 4.242-4.325 0-2.384-1.898-4.325-4.242-4.325zm0 26.483H4.242C1.898 58.742 0 60.683 0 63.067c0 2.393 1.898 4.325 4.242 4.325h64.684c2.344 0 4.242-1.935 4.242-4.325 0-2.384-1.898-4.325-4.242-4.325z"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-menu.svg";